import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Spinner } from "react-bootstrap";
import { useBaseUrl } from "../../../context/AppContext";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/customer/dashboard/MyTreatments.css";
import { checkLoggedInCustomer } from "../../../helper/CustomHelper";
const MyTreatments = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile } = useBaseUrl();
  const [treatments, setTreatments] = useState([]);
  const [loadingBtn, setLoadingBtn] = useState(null);

  const handleViewDetails = (appointmentId) => {
    setLoadingBtn(appointmentId);
    navigate(`/customer/treatments/${appointmentId}`);
  };
  // const handleViewDetails = (id) => {
  //   setLoadingBtn(id);
  //   navigate(`/treatments/${id}`);
  // };

  useEffect(() => {
    checkLoggedInCustomer(navigate);

    axios
      .post(`${baseUrl}/customer/appointment/completedTreatments`, {
        escustomer_id: localStorage.getItem("customerId"),
      })
      .then((res) => {
        setTreatments(res.data.completedTreatments || []);
      })
      .catch((err) => console.log(err));

    // axios
    //   .post(`${baseUrl}/customer/appointment/completedTreatments`)
    //   .then((res) => {
    //     console.log("*****************")
    //     console.log("*****************")
    //     console.log(res.data);
    //     console.log("*****************")
    //     console.log("*****************")

    //     setTreatments(
    //       res.data.completedTreatments || []
    //     );

    //   })
    //   .catch((err) => console.log(err));
  }, []);

  return (
    <div className="sgc-treat-page">
      <Container fluid>
        <h1 className="sgc-treat-title">My Treatments</h1>

        <p className="sgc-treat-section-heading">Completed Treatments</p>
        <div className="sgc-treat-grid">
          {treatments.map((item) => (
            <div className="sgc-treat-card" key={item.id}>
              <div className="sgc-treat-card-img-wrap">
                <img
                  src={`${baseUrlForFile}/${item.estreatment?.image}`}
                  alt={item.estreatment?.title}
                  className="sgc-treat-card-img"
                />
              </div>

              <div className="sgc-treat-card-body">
                <p className="sgc-treat-card-name">{item.estreatment?.title}</p>
                <p className="sgc-treat-card-desc">
                  {item.estreatment?.description}
                </p>
              </div>

              <div className="sgc-treat-rec-footer">
                <button
                  className="sgc-treat-btn-book"
                  onClick={() => handleViewDetails(item.id)}
                  disabled={loadingBtn === item.id}
                >
                  {loadingBtn === item.id ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "View Details"
                  )}
                </button>
                {/* <button
                  className="sgc-treat-btn-book"
                  onClick={() => handleViewDetails(item.estreatment?.id)}
                  disabled={loadingBtn === item.estreatment?.id}
                >
                  {loadingBtn === item.estreatment?.id ? (
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  ) : (
                    "View Details"
                  )}
                </button> */}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default MyTreatments;
